"use client";
import KeyFeaturesComponent from "@/components/keyFeatures";
import { vdiBenefits } from "./constants";

const VdiBenefits = () => {
  return <KeyFeaturesComponent {...vdiBenefits} />;
};

export default VdiBenefits;
